import React, { useState } from "react"
import { CaldaiaDto } from "../../generated"
import CaldaieByMarcaImportTable from "./CaldaieByMarcaImportTable";
import Button from "../../common/components/button";
import { Combo } from "../../common/components/comboBox";
import { RouteComponentProps } from "react-router-dom";
import Actions from "../caldaieActions";
import MarcheCaldaieGlobaleStore from "../MarcheCaldaieGlobalStore";
import { Loading } from "../../common/components/loading";
const Combobox = Combo<string>();

export default (props: RouteComponentProps) => {
    const [state, setState] = useState<{ marca: string | null, selected: CaldaiaDto[] }>({ marca: null, selected: [] });
    const allMarche = MarcheCaldaieGlobaleStore.useAll()?.filter(x =>
        x.length >= 3
        && x.indexOf("---") === -1
        && x.indexOf("___") === -1
        && x.indexOf("000") === -1);
    if (!allMarche)
        return <Loading />

    return < div className="card" >
        <div className="card-header bg-theme d-flex">
            <div className="flex-fill"><h3 className="text-white mb-0">Nuovi modelli caldaie disponibili</h3></div>
        </div>
        <div className="card-body">
            <Combobox
                label="Seleziona la marca di cui vuoi importare i modelli"
                data={allMarche}
                textField={x => x}
                onSelect={x => setState({ ...state, marca: x })}
                value={state.marca}
                allowNull
            />
            {
                state.marca != null &&
                <div className="mt-3 mb-3">

                    <CaldaieByMarcaImportTable
                        marca={state.marca}
                        onSelectionChanged={selected => {
                            console.log(selected);
                            setState({ ...state, selected })
                        }}
                        selection={state.selected}
                    />
                </div>
            }
            <div className="form-actions mt-5">
                <Button
                    disabled={state.selected.length == 0}
                    onClick={() => {
                        setState({ selected: [], marca: null })
                        Actions.inserisciCaldaiePrecaricate(state.selected)
                    }}
                    color="success"> <i className="fa fa-download   " /> Importa
                </Button>
                {" "}
                <Button
                    type="button"
                    color="inverse"
                    onClick={() => props.history.goBack()}>
                    Esci
                </Button>
            </div>
        </div>
    </div >

};